import React from "react";
import packageJson from '../../../package.json';

const Footer = () => {
    let year = new Date().getFullYear();
    return (
        <div id="bottombar">
            <div id="email">Sanef {year} © Version {packageJson.version}</div>
        </div>
    );
}

export default Footer;
